module.exports = __webpack_public_path__ + "img/7-r.cf16d2f5.png";